export default "__VITE_ASSET__c74sZZZF__"